// ─── ICONS ───────────────────────────────────────────────────
// export const IconLibrary = () => (
//     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
//         <rect x="3" y="3" width="7" height="7" rx="1" />
//         <rect x="14" y="3" width="7" height="7" rx="1" />
//         <rect x="3" y="14" width="7" height="7" rx="1" />
//         <rect x="14" y="14" width="7" height="7" rx="1" />
//     </svg>
// );

export const IconEditor = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
        <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
);

export const IconTick = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

export const IconCross = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
);

export const IconCrop = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 2v4H2" />
        <path d="M18 22v-4h4" />
        <path d="M6 6h12v12" />
        <path d="M18 18H6V6" />
    </svg>
);

export const IconAdd = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="2" x2="12" y2="22" />
    <line x1="2" y1="12" x2="22" y2="12" />
  </svg>
);

export const IconTextBox = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <line x1="7" y1="8" x2="17" y2="8" />
    <line x1="7" y1="12" x2="17" y2="12" />
    <line x1="7" y1="16" x2="13" y2="16" />
  </svg>
);

export const IconLink = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);

// Rewind-style: vertical bar + chevron pointing left
export const IconPrevious = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="4" y1="3" x2="4" y2="21" />
    <polyline points="20 4 9 12 20 20" />
  </svg>
);

// Forward-style: chevron pointing right + vertical bar
export const IconNext = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="20" y1="3" x2="20" y2="21" />
    <polyline points="4 4 15 12 4 20" />
  </svg>
);

// Telegram-style paper plane
export const IconSubmit = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="0.5" strokeLinejoin="round">
    <polygon points="2,12 22,3 16,21 12,14" />
    <line x1="12" y1="14" x2="22" y2="3" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const IconLibrary = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="5" width="6" height="16" rx="1" />
    <line x1="4.5" y1="5" x2="4.5" y2="21" />
    <rect x="10" y="2" width="7" height="19" rx="1" />
    <line x1="13" y1="2" x2="13" y2="21" />
    <rect x="19" y="6" width="5" height="15" rx="1" />
    <line x1="21" y1="6" x2="21" y2="21" />
    <line x1="1" y1="21" x2="23" y2="21" />
  </svg>
);

export const IconMathBoxPi = () => (
  <svg width="20" height="20" viewBox="0 0 38 26" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round">
    <rect x="1" y="1" width="36" height="24" rx="4" />
    <text x="7" y="19" fontSize="14" stroke="none" fill="currentColor" fontFamily="Georgia, serif">π</text>
    <line x1="24" y1="7" x2="24" y2="20" strokeWidth="1.8" strokeLinecap="round" />
    <line x1="26" y1="19" x2="33" y2="19" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
  </svg>
);

export function IconMcqOption() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
      <rect x="2" y="3" width="8" height="8" rx="2" stroke="currentColor" strokeWidth="1.6"/>
      <rect x="12" y="3" width="8" height="8" rx="2" stroke="currentColor" strokeWidth="1.6"/>
      <rect x="2" y="13" width="8" height="8" rx="2" stroke="currentColor" strokeWidth="1.6"/>
      <rect x="12" y="13" width="8" height="8" rx="2" stroke="currentColor" strokeWidth="1.6"/>
    </svg>
  );
}

export function IconDiscard() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
      <circle cx="11" cy="11" r="8.5" stroke="currentColor" strokeWidth="1.6"/>
      <line x1="7.5" y1="7.5" x2="14.5" y2="14.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
      <line x1="14.5" y1="7.5" x2="7.5" y2="14.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    </svg>
  );
}